// Contract with POST/PUT /api/it/visits. The form edits date and time separately;
// the API stores them together in `scheduled_for` (YYYY-MM-DDTHH:MM:SS).

export const VISIT_STATUSES = [
  'programada', 'en_camino', 'en_sitio', 'pausada', 'completada', 'cancelada', 'reprogramada',
];

export const DEFAULT_VISIT_TYPES = [
  { code: 'soporte', name: 'Soporte Técnico' },
  { code: 'mantenimiento', name: 'Mantenimiento Preventivo' },
  { code: 'instalacion', name: 'Instalación / Configuración' },
  { code: 'capacitacion', name: 'Capacitación' },
  { code: 'auditoria', name: 'Auditoría / Diagnóstico' },
  { code: 'reparacion', name: 'Reparación' },
];

export const DEFAULT_VISIT_PRIORITIES = [
  { code: 'critica', name: 'Crítica' },
  { code: 'alta', name: 'Alta' },
  { code: 'media', name: 'Media' },
  { code: 'baja', name: 'Baja' },
];

export const EMPTY_VISIT = {
  title: '', client_id: '', location_id: '', tipo: 'soporte', priority: 'media',
  scheduled_date: '', scheduled_time: '', duracion_estimada_min: 60,
  technicians: [], description: '', referencia_ticket: '',
  referencia_proyecto: '', recibe_nombre: '', notes: '',
};

export function splitScheduledFor(value) {
  const [date = '', time = ''] = (value || '').split('T');
  return { scheduled_date: date, scheduled_time: time.slice(0, 5) };
}

export function visitToForm(visit) {
  if (!visit) return { ...EMPTY_VISIT, technicians: [] };
  return {
    ...EMPTY_VISIT,
    title: visit.title || '',
    client_id: visit.client_id || '',
    location_id: visit.location_id || '',
    tipo: visit.tipo || EMPTY_VISIT.tipo,
    priority: visit.priority || EMPTY_VISIT.priority,
    ...splitScheduledFor(visit.scheduled_for),
    duracion_estimada_min: visit.duracion_estimada_min ?? EMPTY_VISIT.duracion_estimada_min,
    technicians: visit.technicians || [],
    description: visit.description || '',
    referencia_ticket: visit.referencia_ticket || '',
    referencia_proyecto: visit.referencia_proyecto || '',
    recibe_nombre: visit.recibe_nombre || '',
    notes: visit.notes || '',
  };
}

export function visitFormToPayload(form) {
  const { scheduled_date, scheduled_time, ...rest } = form;
  return {
    ...rest,
    location_id: form.location_id || null,
    scheduled_for: scheduled_date ? `${scheduled_date}T${scheduled_time || '09:00'}:00` : null,
  };
}

export function visitStatusColor(status) {
  const colors = {
    programada: 'bg-blue-500/20 text-blue-400',
    en_camino: 'bg-yellow-500/20 text-yellow-400',
    en_sitio: 'bg-purple-500/20 text-purple-400',
    en_progreso: 'bg-purple-500/20 text-purple-400',
    pausada: 'bg-orange-500/20 text-orange-400',
    completada: 'bg-green-500/20 text-green-400',
    cancelada: 'bg-red-500/20 text-red-400',
    reprogramada: 'bg-cyan-500/20 text-cyan-400',
  };
  return colors[status] || 'bg-gray-500/20 text-gray-400';
}

export function visitPriorityColor(priority) {
  const colors = {
    critica: 'bg-red-500/20 text-red-400',
    alta: 'bg-orange-500/20 text-orange-400',
    media: 'bg-yellow-500/20 text-yellow-400',
    baja: 'bg-green-500/20 text-green-400',
  };
  return colors[priority] || 'bg-gray-500/20 text-gray-400';
}

export function visitStats(visits) {
  const count = (...statuses) => visits.filter((visit) => statuses.includes(visit.status)).length;
  return {
    total: visits.length,
    scheduled: count('programada'),
    onSite: count('en_sitio', 'en_progreso'),
    completed: count('completada'),
    cancelled: count('cancelada'),
  };
}
